<template>
    <a-row type="flex" justify="center" align="middle" class="home">
        <a-col :span="8">

            <a-spin :spinning="spinning" size="large">
                <a-card class="login-card" bordered={false}>
                    <div class="login-form">
                        <a-typography-title level="2" class="login-title">Tax Agent</a-typography-title>
                        <div class="login-lab">
                            <label>欢迎使用中税通智能体</label>
                            <br>
                            <label>智慧赋能、科技创新</label>
                        </div>
                        <a-form @submit="handleLogin" style="margin-top: 40px;">
                            <a-form-item>
                                <a-input v-model:value="usernames" placeholder="用户名" class="rounded-input">
                                    <template #prefix>
                                        <UserOutlined style="color: rgba(0, 0, 0, 0.25)" />
                                    </template>
                                </a-input>
                            </a-form-item>

                            <a-form-item>
                                <a-input v-model:value="passwords" type="password" placeholder="密码"
                                    class="rounded-input">
                                    <template #prefix>
                                        <LockOutlined style="color: rgba(0, 0, 0, 0.25)" />
                                    </template>
                                </a-input>
                            </a-form-item>

                            <a-form-item>
                                <a-button type="primary" html-type="submit" block class="login-button"
                                    :disabled="submitting">登录</a-button>
                            </a-form-item>
                        </a-form>
                    </div>
                </a-card>
            </a-spin>

            <!-- 滑块验证：登录前先完成验证，滑完拿到一次性凭证再提交登录 -->
            <VerifySlider v-model:open="sliderVisible" :title="sliderTitle" @success="onSliderSuccess"
                @cancel="onSliderCancel" />

        </a-col>
    </a-row>
</template>

<script>
import { UserOutlined, LockOutlined } from '@ant-design/icons-vue';
import { checkToken, loginUser } from '@/api/auth';
import VerifySlider from '@/components/VerifySlider.vue';
import { useMenuStore, useUserStore } from '@/store/index';
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { message } from 'ant-design-vue';
export default {
    name: 'LoginPage',
    components: {
        UserOutlined,
        LockOutlined,
        VerifySlider,
    },
    setup() {
        const spinning = ref(false);
        const menuStore = useMenuStore();
        const userStore = useUserStore();
        const usernames = ref('');
        const passwords = ref('');
        const router = useRouter();
        // 滑块弹窗开关、标题、提交中（滑动验证期间置灰登录按钮）
        const sliderVisible = ref(false);
        const sliderTitle = ref('请完成滑动验证');
        const submitting = ref(false);
        // 滑块凭证：一次性、3 分钟有效，由前端按后端公式本地算出并在此暂存
        const CAPTCHA_EXPIRE = 3 * 60 * 1000;
        const captchaVerification = ref('');
        const captchaTime = ref(0);
        const isCredentialValid = () => {
            return !!captchaVerification.value && Date.now() - captchaTime.value < CAPTCHA_EXPIRE;
        };
        const clearCredential = () => {
            captchaVerification.value = '';
            captchaTime.value = 0;
        };

        // 根据角色跳转对应首页
        const redirectByRole = () => {
            if (userStore.isBizUser) {
                router.push('/app');
            } else {
                router.push('/home');
            }
        };

        //检查token
        const check = async () => {
            const response = await checkToken();
            if (response.code == 200 && response.data == true) {
                redirectByRole();
            }
        };
        // 打开滑块（滑动验证期间置灰登录按钮，防止重复提交）
        const openSlider = () => {
            submitting.value = true;
            sliderVisible.value = true;
        };
        // 滑块取消：不发登录请求
        const onSliderCancel = () => {
            sliderVisible.value = false;
            submitting.value = false;
        };
        // 滑块验证通过：暂存一次性凭证并提交登录
        const onSliderSuccess = (verification) => {
            sliderVisible.value = false;
            captchaVerification.value = verification;
            captchaTime.value = Date.now();
            Login(usernames.value, passwords.value, verification);
        };
        const handleLogin = () => {
            if (submitting.value) {
                return;
            }
            if (usernames.value == '' || passwords.value == '') {
                message.error('请填写账户和密码');
                return;
            }
            //清空菜单
            menuStore.removeAll();
            // 已有未使用且未过期的凭证就直接提交，否则先弹滑块
            if (isCredentialValid()) {
                submitting.value = true;
                Login(usernames.value, passwords.value, captchaVerification.value);
                return;
            }
            clearCredential();
            openSlider();
        };
        //登录
        const Login = async (name, pas, verification) => {
            //加载遮罩
            spinning.value = true;
            // doLogin 走统一封装（签名+加密），仅 body 多一个滑块凭证
            const response = await loginUser(
                { account: name, passWord: pas, device: 'PC', captchaVerification: verification },
                { silent: true }
            );
            spinning.value = false;
            // 凭证一次性：提交后立即作废，下次登录必须重新滑动
            clearCredential();
            if (response.code == 200) {
                submitting.value = false;
                localStorage.setItem("token", response.data.tokenValue);
                localStorage.setItem("tenantId", response.data.tenantId);
                localStorage.setItem("menu", JSON.stringify(response.data.menus));
                // 保存用户权限信息
                userStore.setUserInfo({
                    menus: response.data.menus || [],
                    permissions: response.data.permissions || [],
                });
                // 根据角色跳转
                redirectByRole();
                return;
            }
            // 凭证一次性：任何一次失败后都必须重新滑动获取新凭证，账号密码保留不清空
            const msg = response.msg || '登录失败，请稍后重试';
            if (msg.indexOf('滑块') > -1 || msg.indexOf('请先完成') > -1) {
                message.error('请重新完成滑块验证');
                openSlider();
                return;
            }
            submitting.value = false;
            sliderTitle.value = '请重新完成滑块验证';
            message.error(msg);
        };

        check();
        return {
            usernames,
            passwords,
            router,
            spinning,
            submitting,
            sliderVisible,
            sliderTitle,
            handleLogin,
            onSliderSuccess,
            onSliderCancel
        };
    },
};
</script>

<style scoped>
/* 登录页背景：深空底色 + 点阵网格 + 双色柔光，纯 CSS 实现 */
.home {
    position: relative;
    height: 100vh;
    width: 100%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    /* 底：上方偏亮的深色渐变，边缘压暗，把视觉收拢到中间 */
    background: radial-gradient(ellipse 90% 70% at 50% -10%, #14232e 0%, #0b131a 45%, #06090d 100%);
}

/* 点阵网格层：径向遮罩让四周自然淡出，不抢主体 */
.home::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image: radial-gradient(rgba(64, 224, 180, 0.55) 1.1px, transparent 1.1px);
    background-size: 26px 26px;
    -webkit-mask-image: radial-gradient(ellipse 78% 68% at 50% 42%, #000 24%, transparent 80%);
    mask-image: radial-gradient(ellipse 78% 68% at 50% 42%, #000 24%, transparent 80%);
    pointer-events: none;
}

/* 柔光层：品牌绿 + 青蓝两团光斑，缓慢漂移 */
.home::after {
    content: '';
    position: absolute;
    inset: -14%;
    background:
        radial-gradient(circle 460px at 20% 24%, rgba(39, 174, 96, 0.50), transparent 66%),
        radial-gradient(circle 520px at 80% 76%, rgba(34, 211, 238, 0.40), transparent 68%),
        radial-gradient(circle 380px at 62% 10%, rgba(46, 229, 157, 0.24), transparent 70%);
    animation: bg-drift 22s ease-in-out infinite alternate;
    pointer-events: none;
}

@keyframes bg-drift {
    0% {
        transform: translate3d(0, 0, 0) scale(1);
    }

    100% {
        transform: translate3d(2.5%, -2%, 0) scale(1.08);
    }
}

.login-card {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    border-radius: 12px;
    -webkit-animation: scale-up-center .4s cubic-bezier(.39, .575, .565, 1.000) both;
    animation: scale-up-center .4s cubic-bezier(.39, .575, .565, 1.000) both
}

@keyframes scale-up-center {
    0% {
        transform: scale(.5)
    }

    100% {
        transform: scale(1)
    }
}

.login-form {
    max-width: 300px;
    height: 450px;
    margin: auto;
}

.login-title {
    text-align: center;
    margin-bottom: 18px;
    color: #34495e;
    margin: 20px;
    animation: focus-in-expand .8s cubic-bezier(.25, .46, .45, .94) both
}

@keyframes focus-in-expand {
    0% {
        letter-spacing: -.5em;
        filter: blur(12px);
        opacity: 0
    }

    100% {
        filter: blur(0);
        opacity: 1
    }
}

.rounded-input {
    border-radius: 8px;
    padding: 10px;
}

.login-button {
    border-radius: 8px;
    height: 40px;
    font-size: 16px;
    background-color: #1890ff;
    border-color: #1890ff;
    margin-top: 5px;
}

.login-button:hover {
    background-color: #40a9ff;
    border-color: #40a9ff;
}

.login-lab {
    text-align: center;
    animation: focus-in-expand .8s cubic-bezier(.25, .46, .45, .94) both
}

a-input {
    margin-bottom: 16px;
}
</style>
